import { Grid, TableBody } from '@mui/material';
import { BridgeTable } from '../../Bridge/BridgeTable';
import {
  StyledTableCell,
  StyledWithdrawTableRow,
} from '../../../Components/MaterialTableStyle/StyleTableCell';
import BigNumber from 'bignumber.js';
import { FormatDate } from '../../../Components/DateFormats/DateFromat';
import cx from 'classnames';
import { isDisabled } from '../../../utils/constants';
import React, { useState } from 'react';
import { useStakingContext } from '../contexts/staking.context';

export const VaultUnstakingTable = ({ unstakeList, unstakeColumns }) => {
  const { handleFinalizeUnstake } = useStakingContext();
  const [transactionIdClaimed, setTransactionIdClaimed] = useState([0]);

  const finalizeUnstake = (
    stakingAddress: string,
    nonce: number,
    id: number,
  ) => {
    void handleFinalizeUnstake(stakingAddress, nonce, id);
    setTransactionIdClaimed((prev) => [...prev, nonce]);
  };

  return (
    <Grid
      container
      display={'flex'}
      flexDirection={'column'}
      alignItems={'center'}
      justifyContent={'center'}
      className="BridgeGlassCard px-3 py-2 mb-20"
    >
      <BridgeTable
        columns={unstakeColumns}
        isEmpty={unstakeList?.length === 0}
        isLoading={false}
      >
        {unstakeList?.length > 0 && (
          <TableBody
            sx={{
              backgroundColor: '#28282B',
              padding: '16px',
              borderRadius: '12px',
            }}
          >
            {unstakeList.map((unstake, idx) => (
              <StyledWithdrawTableRow
                key={`withdraw-${idx}`}
                style={
                  idx % 2 == 0
                    ? { background: '#3B3B3D' }
                    : { background: 'transparent' }
                }
              >
                <StyledTableCell
                  sx={{
                    fontFamily: 'Poppins',
                    fontSize: { xs: '12px', md: '16px !important' },
                    fontWeight: '500',
                    lineHeight: '24px',
                  }}
                >
                  <span>
                    {BigNumber(unstake?.amount)
                      .div(Math.pow(10, 18))
                      .toString()}{' '}
                  </span>
                  OZK
                </StyledTableCell>
                <StyledTableCell
                  sx={{
                    fontFamily: 'Poppins',
                    fontSize: { xs: '12px', md: '16px !important' },
                    fontWeight: '500',
                    lineHeight: '24px',
                  }}
                >
                  <span>
                    {FormatDate(new Date(unstake?.blockTimestamp).getTime())}
                  </span>
                </StyledTableCell>
                <StyledTableCell
                  sx={{
                    fontFamily: 'Poppins',
                    fontSize: { xs: '12px', md: '16px !important' },
                    fontWeight: '500',
                    lineHeight: '24px',
                  }}
                >
                  {Date.now() > new Date(unstake?.claimableAt).getTime() &&
                  !unstake.processed ? (
                    <Grid
                      className={cx([
                        'px-4 py-2 rounded-[20px]',
                        transactionIdClaimed.includes(unstake?.nonce)
                          ? 'bg-[#94e3f2]'
                          : 'cursor-pointer  bg-[#5773ff]',
                      ])}
                      onClick={() => {
                        !isDisabled &&
                          !transactionIdClaimed.includes(unstake?.nonce) &&
                          finalizeUnstake(
                            unstake.stakingAddress,
                            unstake.nonce,
                            unstake.id,
                          );
                      }}
                    >
                      <p className="text-center">
                        {transactionIdClaimed.includes(unstake?.nonce)
                          ? 'Claiming'
                          : 'Claim'}
                      </p>
                    </Grid>
                  ) : unstake.processed ? (
                    <span>
                      {FormatDate(new Date(unstake?.updatedAt).getTime())}
                    </span>
                  ) : (
                    <span>
                      {FormatDate(new Date(unstake?.claimableAt).getTime())}
                    </span>
                  )}
                </StyledTableCell>
              </StyledWithdrawTableRow>
            ))}
          </TableBody>
        )}
      </BridgeTable>
    </Grid>
  );
};
